module.exports = __webpack_public_path__ + "static/media/finish.fc207f46.png";